import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_OBJECTIVES_CONVERTER } from './index'
import { TrainingObjectivesConverter } from './training-objectives.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingObjectivesFeature: {
          module: () => import('./training-objectives.module').then((m) => m.TrainingObjectivesModule),
          cmsComponents: ['training_objectives'],
        },
      }
    }),
    {
      provide: TRAINING_OBJECTIVES_CONVERTER,
      useExisting: TrainingObjectivesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_objectives: TRAINING_OBJECTIVES_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingObjectivesFeatureModule {
}
